// Анимационные примитивы: пружины и шум.
// Пружина вместо lerp — движение получает инерцию и «дожим», это и читается
// как сочность. Шум вместо синуса в тряске — удар выглядит ударом, а не качкой.

/**
 * Пружина с демпфированием. По умолчанию близка к критической (без болтанки).
 * stiffness — жёсткость, damping — гашение; damping ≈ 2·√stiffness = критическая.
 */
export function createSpring(value = 0, { stiffness = 180, damping = null } = {}) {
  let current = value;
  let velocity = 0;
  let target = value;
  const damp = damping == null ? 2 * Math.sqrt(stiffness) : damping;

  return {
    get value() { return current; },
    get velocity() { return velocity; },
    set to(v) { target = v; },
    setTarget(v) { target = v; },
    // Мгновенно поставить значение (без перелёта): смена уровня, рестарт
    reset(v) { current = target = v; velocity = 0; },
    // Толчок скорости — для squash-удара и FOV-kick
    kick(v) { velocity += v; },
    update(dt) {
      // Шаг ограничиваем: на просадке кадра пружина иначе взрывается
      const step = Math.min(dt, 1 / 30);
      velocity += (target - current) * stiffness * step;
      velocity *= Math.exp(-damp * step);
      current += velocity * step;
      return current;
    },
  };
}

// Детерминированный value-noise: плавный, но непредсказуемый — для тряски
function hash(n) {
  const s = Math.sin(n * 127.1) * 43758.5453;
  return s - Math.floor(s);
}

export function noise1D(t) {
  const i = Math.floor(t);
  const f = t - i;
  const u = f * f * (3 - 2 * f); // сглаживание
  return (hash(i) * (1 - u) + hash(i + 1) * u) * 2 - 1;
}

/**
 * Затухающая тряска на шуме. Возвращает смещение по осям.
 * seed разводит оси, чтобы они не двигались синхронно.
 */
export function shakeOffset(amount, t) {
  return {
    x: noise1D(t * 34) * amount,
    y: noise1D(t * 41 + 17.3) * amount * 0.6,
  };
}
